import React, { useState } from 'react'
import Hamburger from './Hamburger';
import { Link } from 'react-scroll';

const Curve = () => {
	const [isOpen, setIsOpen] = useState(false);

	const navItems = [
		{ to: "contact", text: "Contact me", className: "c6", offset: -10 },
		{ to: "ach", text: "Achievements", className: "c5", offset: 0 },
		{ to: "proj", text: "Projects", className: "c4", offset: -100 },
		{ to: "about", text: "About", className: "c3", offset: -150 },
		{ to: "home", text: "Home", className: "c2", offset: -100 }
	];

	return (
		<div className='circleNav'>
			<div className={`circleCont ${isOpen ? "openCircles" : ""}`}>
				{navItems.map((item, index) => (
					<Link
						key={item.to}
						onClick={() => setIsOpen(!isOpen)}
						className={`circle ${item.className}`}
						to={item.to}
						spy={true}
						smooth={true}
						offset={item.offset}
						duration={500}
					>
						<span className="circleLinks">{item.text}</span>
					</Link>
				))}
				<div className="circle c1"></div>
			</div>
			<Hamburger isOpen={isOpen} handleOpen={() => setIsOpen(!isOpen)} />
		</div >
	)
}

export default Curve